import LogList from "@/pages/components/LogList";
import {Box, Card, Stack} from "@mui/material";
// @ts-ignore
import useMobileDetect from "next-device-detection";
import classes from '../css/index.module.less'
import {getUrlParams} from "@/utils/utils.js";
import RpIcon from "@/components/RpIcon";
import React from "react";
import {useNavigate} from "react-router-dom";
import SimpleHeader from "@/pages/components/Headers/SimpleHeader";
import {useTranslation} from "react-i18next";

function AssetsTransList() {
  const detectMobile = useMobileDetect();
  const bussinessType = getUrlParams("bussiness_type");
  const navigate = useNavigate()
  const {t} = useTranslation()
  return (
    <>
      {
        detectMobile.isMobile &&
        <Stack direction="column" sx={{
            width: '100%', flex: 1, overflowY: 'hidden',
          }}>
          <SimpleHeader
            backEnable
            title={t('assets_list')}
          />
          <Stack direction="column" sx={{
            width: '100%',
            padding: '16px 16px 0',
            height: '100%'}}>
            <LogList bussinessType={''} isCompact={false} pageable/>
          </Stack>
        </Stack>
      }
    </>

  );
}

export default AssetsTransList;
